import { type FC } from "react";
import { type SchoolLogCassetteProps } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/profile_show_props";
import { EditPageLink } from "./edit_page_link";
import * as styles from "../styles.css";

export const SchoolLogCassette: FC<SchoolLogCassetteProps> = ({
  schoolLog: { schools, schoolsNote },
  editPath,
}) => (
  <>
    {schools.length > 0 && (
      <ul className={styles.innerCassetteList}>
        {schools.map(
          ({ schoolName, course, graduatedYear, graduatedMonth, isWillGraduate }, index) => (
            <li key={schoolName}>
              <section className={styles.innerCassette}>
                <div className={styles.innerCassetteHeadingOuter}>
                  <h4 className={styles.innerCassetteHeading}>
                    <span>学歴{index + 1}</span>
                    <EditPageLink url={`${editPath}#cassette-${index}`} />
                  </h4>
                </div>
                <div className={styles.innerCassetteContent}>
                  <div className={styles.tableList}>
                    <dt>学校名</dt>
                    <dd>{schoolName}</dd>
                    {course && (
                      <>
                        <dt>学部・学科・コース</dt>
                        <dd>{course}</dd>
                      </>
                    )}
                    <dt>卒業年</dt>
                    <dd>
                      {graduatedYear}年{graduatedMonth && ` ${graduatedMonth}月`}
                      {isWillGraduate && <> 卒業予定</>}
                    </dd>
                  </div>
                </div>
              </section>
            </li>
          ),
        )}
      </ul>
    )}
    {schoolsNote && <>{schoolsNote}</>}
  </>
);
